import { Injectable } from '@angular/core';
import { HttpService } from '@app/shared/services/http/http.service';
import { UrlService } from '@app/shared/services/url/url.service';

import * as AuthAction from '../../store/auth/auth.actions';

@Injectable()
export class AuthService {
  constructor(private _httpService: HttpService, private _urlService: UrlService) {}

  authToken(data: AuthAction.AuthTokenStateModel) {
    const url = this._urlService.getUrl('COLLECT.authenticate');
    return this._httpService.post(url, data);
  }

  updateToken(token: string) {
    const url = this._urlService.getUrl('COLLECT_TVF.registerFullAccess');
    return this._httpService.post(url, { NewTokenMock: token });
  }
}
